import { ReactComponent as AnalyticsIcon } from "assets/icons/analyticsIcon.svg";
import { ReactComponent as ApplicationIcon } from "assets/icons/applicationsIcon.svg";
import { ReactComponent as ClientIcon } from "assets/icons/clientsIcon.svg";
import { ReactComponent as UserIcon } from "assets/icons/usersIcon.svg";
import { ReactComponent as ModelIcon } from "assets/icons/modelsIcon.svg";
import { ReactComponent as ServiceIcon } from "assets/icons/services.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/settings.svg";
import { ReactComponent as DefectsIcon } from "assets/icons/defects.svg";
import { ReactComponent as FeedbackIcon } from "assets/icons/feedback.svg";
import { ReactComponent as NoticeboardsIcon } from "assets/icons/noticeboards.svg";
import { ReactComponent as HasQuestion } from "assets/icons/question_dark.svg";
import MemoryIcon from "@mui/icons-material/Memory";
import PsychologyRoundedIcon from "@mui/icons-material/PsychologyRounded";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import access from "helpers/access";
import roles from "helpers/roles";
import i18n from "i18n";
import { useFeatureFlags } from "contexts/FeatureFlagsContext";
import {
	applicationListPath,
	clientsPath,
	modelsPath,
	usersPath,
	servicesPath,
	analyticsPath,
	defectsPath,
	defectExportPath,
	feedbackPath,
	analysisPath,
	noticeboardPath,
	settingPath,
	clientSettingPath,
	newAnalyticsPath,
	aiConfigurationPath,
	releaseNotesAdminPath,
	maintenanceBannerAdminPath,
} from "helpers/routePaths";

// Wrapper for MUI icons to match custom icon sizing
const BackgroundJobsIcon = (props) => (
	<MemoryIcon {...props} sx={{ fontSize: 32, ...props.sx }} />
);
const AIConfigIcon = (props) => (
	<PsychologyRoundedIcon {...props} sx={{ fontSize: 32, ...props.sx }} />
);
const ReleaseNotesAdminIcon = (props) => (
	<CampaignRoundedIcon {...props} sx={{ fontSize: 32, ...props.sx }} />
);
const MaintenanceBannerAdminIcon = (props) => (
	<ConstructionRoundedIcon {...props} sx={{ fontSize: 32, ...props.sx }} />
);

const baseNavItems = (customCaptions) => [
	{
		activeName: "Clients",
		name: i18n.t("title.clients"),
		icon: ClientIcon,
		path: clientsPath,
		access: "",
		roles: [roles.superAdmin],
	},
	{
		activeName: "Applications",
		name: i18n.t("label.applications"),
		icon: ApplicationIcon,
		path: applicationListPath,
		access: "",
		roles: [roles.superAdmin],
	},
	{
		activeName: "Client",
		name: i18n.t("title.clientSetting"),
		icon: ClientIcon,
		path: clientSettingPath,
		access: "",
		roles: [roles.clientAdmin],
	},
	{
		activeName: "Hangfire",
		name: i18n.t("label.backgroundJobs"),
		icon: BackgroundJobsIcon,
		path: "#hangfire",
		access: "",
		roles: [roles.superAdmin],
		isExternal: true,
	},
	{
		activeName: `Models`,
		name: `${customCaptions?.modelPlural ?? "Models"}`,
		icon: ModelIcon,
		path: modelsPath,
		access: access.modelAccess,
		roles: "",
	},
	{
		activeName: "Services",
		name: `${customCaptions?.servicePlural ?? "Services"}`,
		icon: ServiceIcon,
		path: servicesPath,
		access: access.serviceAccess,
		roles: "",
	},
	{
		activeName: "Defects",
		name: `${customCaptions?.defectPlural ?? "Defects"}`,
		icon: DefectsIcon,
		path: defectsPath,
		access: access.defectAccess,
		roles: "",
	},
	{
		activeName: "Analytics",
		name: i18n.t("label.analytics"),
		icon: AnalyticsIcon,
		path: newAnalyticsPath,
		access: access.analyticsAccess,
		roles: "",
	},
	{
		activeName: "Analysis",
		name: i18n.t("label.analysis"),
		icon: ModelIcon,
		path: analysisPath,
		access: access.analysisAccess,
		roles: "",
	},
	{
		activeName: "DefectExport",
		name: i18n.t("label.defectExport"),
		icon: ModelIcon,
		path: defectExportPath,
		access: access.defectExportAccess,
		roles: "",
	},
	{
		activeName: "Feedback",
		name: `${customCaptions?.feedbackPlural ?? "Feedbacks"}`,
		icon: FeedbackIcon,
		path: feedbackPath,
		access: access.feedbackAccess,
		roles: "",
	},
	{
		activeName: "Noticeboards",
		name: `${customCaptions?.tutorialPlural ?? "Noticeboard"}`,
		icon: NoticeboardsIcon,
		path: noticeboardPath,
		access: access.noticeboardAccess,
		roles: "",
	},
	{
		activeName: "Users",
		name: `${customCaptions?.userPlural ?? "Users"}`,
		icon: UserIcon,
		path: usersPath,
		access: access.userAccess,
		roles: [roles.superAdmin, roles.clientAdmin, roles.siteUser],
		hideToReseller: true,
	},
	{
		activeName: "AIConfiguration",
		name: i18n.t("title.aiConfiguration"),
		icon: AIConfigIcon,
		path: aiConfigurationPath,
		access: "",
		roles: [roles.superAdmin],
	},
	{
		activeName: "release-notes-admin",
		name: "Release Notes",
		icon: ReleaseNotesAdminIcon,
		path: releaseNotesAdminPath,
		access: "",
		roles: [roles.superAdmin],
	},
	{
		activeName: "maintenance-banner-admin",
		name: "System Admin",
		icon: MaintenanceBannerAdminIcon,
		path: maintenanceBannerAdminPath,
		access: "",
		roles: [roles.superAdmin],
	},
	{
		activeName: "Settings",
		name: i18n.t("label.settings"),
		icon: SettingsIcon,
		path: settingPath,
		access: access.settingsAccess,
		roles: "",
	},
	{
		activeName: "Support",
		name: i18n.t("label.support"),
		icon: HasQuestion,
		path: "",
		// access: access.settingsAccess,
		access: access.knowledgeBaseAccess, // Knowledge base access should always be available
		roles: "",
	},
];

function useNavList(customCaptions) {
	const { isEnabled } = useFeatureFlags();
	const items = [...baseNavItems(customCaptions)];

	return items;
}

export default useNavList;
